export default __webpack_public_path__ + "media/images/Icon_closePopUp-138d3bf33ba41ab49738a427417c6d16.png";